import { AreaAccountingProductAPI } from "../api";

export class AreaAccountingProduct {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async getAreaAccountingProductByMarket(marketId) {
    const { data } = await AreaAccountingProductAPI.getAreaAccountingProductByMarket(marketId);
    data.result.map((item) => (item = new AreaAccountingProduct(item)));
    return data.result;
  }
  static async createAreaAccountingProduct(formData) {
    const { data } = await AreaAccountingProductAPI.createAreaAccountingProduct(formData);
    data.result = new AreaAccountingProduct(data.result);
    return data.result;
  }
  static async updateAreaAccountingProduct(formData) {
    const { data } = await AreaAccountingProductAPI.updateAreaAccountingProduct(formData);
    data.result = new AreaAccountingProduct(data.result);
    return data.result;
  }
  static async createUpdateAreaAccountingProduct(formData) {
    const { data } = await AreaAccountingProductAPI.createUpdateAreaAccountingProduct(formData);
    data.result = new AreaAccountingProduct(data.result);
    return data.result;
  }
  static async getAreaAccountingProductByAreas(areaIds) {
    const { data } = await AreaAccountingProductAPI.getAreaAccountingProductByAreas(areaIds);
    data.result.map((item) => (item = new AreaAccountingProduct(item)));
    return data.result;
  }
  static async getAreaAccountingProduct(id) {
    const { data } = await AreaAccountingProductAPI.getAreaAccountingProduct(id);
    data.result = new AreaAccountingProduct(data.result);
    return data.result;
  }
  static async getAreaAccountingProductPrice(formData) {
    const { data } = await AreaAccountingProductAPI.getAreaAccountingProductPrice(formData);
    data.result = data.result ? new AreaAccountingProduct(data.result) : undefined;
    return data.result;
  }
}